import { render } from "./Start.vue?vue&type=template&id=0fe577ce"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"
script.render = render

export default script